module.exports = __webpack_public_path__ + "static/media/thumbnail-IMG_1058.3561d115.jpg";